import { render, staticRenderFns } from "./FlowBlockContainer.vue?vue&type=template&id=2c6432cb&"
import script from "./FlowBlockContainer.vue?vue&type=script&lang=js&"
export * from "./FlowBlockContainer.vue?vue&type=script&lang=js&"
import style0 from "./FlowBlockContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports